import { functions } from '@/functions';
import miniToastr from 'mini-toastr'
import {CONSTANTS} from '@/constants'

export const functions_loaders = {
    data: function () {
        return {
            balance:null,
            countries :[],
            dashboard:null,
            drivers:null,

            order: null,
            guests:[],
            quotas:null,
            hotel_quotas:null,
            roles:[],
            telenums:[],
            token:null,
            user : null,
            users :[],
            telecalls:[],
            voucher:null,
            vouchers:[],
            teams:[],
            teams_dict:[],
            upload_result:null,
            no_quotas:null,
            cities_loaded:false,
            countries_loaded:false,
            teams_loaded:false,
        };
    },
    mixins: [functions],

    methods: {

        /*
         *   Список телефонных номеров
         */

        loadTelenumsForVoucher: function (voucher_id, onSuccess=null, param=null) {
            if (!this.isTelenumsLoaded() && voucher_id) {
                this.telenums = [];
                this.httpPrepare();
                this.$http.get(this.apiurl('voucher/' + voucher_id + '/telenums')).then(function (response) {
                    response = this.httpSuccess(response);
                    this.telenums = response.payload;
                    this.executeFunction(onSuccess, param);
                }, this.httpError)
            }
            return this;
        },

        loadTelenumsForOrder: function (order_id, onSuccess=null, param=null) {
            if (!this.isTelenumsLoaded() && order_id) {
                this.telenums = null;
                this.httpPrepare();
                this.$http.get(this.apiurl('order/' + order_id + '/telenums')).then(function (response) {
                    response = this.httpSuccess(response);
                    this.telenums = response.payload;
                    this.executeFunction(onSuccess, param);
                }, this.httpError)
            }
            return this;
        },

        resetTelenums: function () {
            this.telenums = [];
            return this;
        },

        isTelenumsLoaded: function () {
            return (this.telenums !== null) && this.telenums.length;
        },


        /**
         * Загрузка списка туристов для путевки
         */


        /**
         * Прочее
         */


        resetGuests: function () {
            this.guests = [];
            return this;
        },

        isGuestsLoaded: function () {
            return (this.guests !== null) && this.guests.length;
        },

        /*
         * операции с квотами
         */

        loadQuotas: function (hotel_id, df, dt, onSuccess=null, param=null) {
            if (!this.isQuotasLoaded() && hotel_id && df && dt && df!==null && dt!==null) {
                this.quotas = [];
                df.setDate(df.getDate() - 7);
                dt.setDate(dt.getDate() + 7);
                df = df.toISOString().slice(0, 10);
                dt = dt.toISOString().slice(0, 10);
                this.httpPrepare();
                this.$http.get(this.apiurl ('hotel/' + hotel_id + '/quotas/' + df + '/' + dt )).then(function (response) {
                    response = this.httpSuccess(response);
                    this.quotas = response.payload;
                    if (!this.isQuotas()) {
                        this.no_quotas = "Квот для выбранного отеля не найдено";
                    }
                    this.executeFunction(onSuccess, param);
                }, this.httpError)

                this.$http.get(this.apiurl ('hotel/' + hotel_id + '/quotas' )).then(function (response) {
                    response = this.httpSuccess(response);
                    this.hotel_quotas = response.payload;
                    this.executeFunction(onSuccess, param);
                }, this.httpError)
            }
        },

        resetQuotas: function () {
            this.quotas = null;
            this.no_quotas = null;
            return this;
        },

        isQuotasLoaded: function () {
            return (this.quotas !== null) && this.quotas;
        },

        isQuotas: function () {
            return (this.quotas !== null) && this.quotas && this.quotas.count  &&  this.quotas.rooms &&  (this.quotas.rooms !== null) &&this.quotas.rooms.length;
        },

        isNoQuotas: function () {
            return (this.no_quotas !== null) && this.no_quotas;
        },


        /*
         *   Список пользователей
         */

        loadCompanyUsers: function (company_id, onSuccess=null, param=null) {
            if (!this.isUsersLoaded()) {
                this.users_loaded = false;
                this.httpPrepare();
                this.$http.get(this.apiurl('company/'+company_id+'/users')).then(function (response) {
                    response = this.httpSuccess(response);
                    this.users = response.payload;
                    this.users_loaded = true;
                    this.executeFunction(onSuccess, param);
                }, this.httpError)
            }
            return this;
        },

        loadUsers: function (onSuccess=null, param=null) {
            console.log('loadUsers');
            if (!this.isUsersLoaded()) {
                this.users_loaded = false;
                this.httpPrepare();
                this.$http.get(this.apiurl('user')).then(function (response) {
                    response = this.httpSuccess(response);
                    this.users = response.payload;
                    this.users_loaded = true;
                    this.executeFunction(onSuccess, param);
                }, this.httpError)
            }
            return this;
        },

        resetUsers: function () {
            this.users = [];
            return this;
        },

        isUsersLoaded: function () {
            return (this.users !== null) && this.users.length  && this.users_loaded;
        },


        /*
         *      Путевка
         */

        loadVoucher: function (voucher_id, onSuccess=null, param=null) {
            //console.log('loadVoucher '+voucher_id   )
            if (!this.isVoucherLoaded() && voucher_id) {
                this.httpPrepare();
                this.$http.get(this.apiurl('voucher/' + voucher_id)).then(function (response) {
                        //console.log('loadVoucher  response = ', response)
                        response = this.httpSuccess(response);
                        // console.log('loadVoucher  response = ', response)
                        // console.log('loadVoucher  response.payload = ', response.payload)
                        // console.log('loadVoucher  onSuccess voucher_id = ', voucher_id)
                        // console.log('loadVoucher  onSuccess this', this)
                        // console.log('loadVoucher  onSuccess this.voucher = ', this.voucher)
                        // console.log('loadVoucher  onSuccess '+ voucher_id)
                        this.voucher = response.payload;
                        this.executeFunction(onSuccess, param);
                    }, this.httpError)
            }
            return this;
        },

        resetVoucher: function () {
            this.voucher = null;
            return this;
        },

        isVoucherLoaded: function () {
            return !!(this.is(this.voucher) && this.voucher.id);
        },

        /*
         *      Путевки
         */

        loadCheckins: function (start, end, onSuccess=null, param=null) {
            console.log('loadCheckins')
            if (!this.isVouchersLoaded()) {
                this.httpPrepare();

                this.$http.put(this.apiurl('voucher/checkins'), {start_at:start, end_at:end}).then(function (response) {
                        response = this.httpSuccess(response);
                        this.vouchers = response.payload;
                        console.log('loadCheckins', this.vouchers);
                        this.executeFunction(onSuccess, param);
                    }, this.httpError)
            }
            return this;
        },

        resetVouchers: function () {
            console.log('resetVouchers');
            this.vouchers = [];
            return this;
        },

        isVouchersLoaded: function () {
            return (this.vouchers !== null) && this.vouchers.length;
        },

        /*
         *  Телефонные звонки
         */

        loadTelecallsForVoucher: function (voucher_id, onSuccess=null, param=null) {
            //console.log('loadTelecallsForVoucher');
            if (!this.isTelecallsLoaded() && voucher_id) {
                this.telecalls = [];
                this.httpPrepare();
                this.$http.get(this.apiurl('voucher/' + voucher_id + '/telecalls')).then(function (response) {
                    response = this.httpSuccess(response);
                    this.telecalls = response.payload;
                    this.executeFunction(onSuccess, param);
                }, this.httpError)
            }
            return this;
        },


        loadTelecallsForOrder: function (order_id, onSuccess=null, param=null) {
            console.log('loadTelecallsForOrder');
            if (!this.isTelecallsLoaded() && order_id) {
                this.telecalls = [];
                this.httpPrepare();
                this.$http.get(this.apiurl('order/' + order_id + '/telecalls')).then(function (response) {
                    response = this.httpSuccess(response);
                    console.log('loadTelecallsForOrder - OK');
                    this.telecalls = response.payload;
                    this.executeFunction(onSuccess, param);
                }, this.httpError)
            }
            return this;
        },

        resetTelecalls: function () {
            this.telecalls = [];
            return this;
        },

        isTelecallsLoaded: function () {
            return (this.telecalls !== null) && this.telecalls.length;
        },



        /*
         *   Пользователь
         */

        loadUser: function (user_id, onSuccess=null, param=null) {
            if (!this.isUserLoaded()) {
                this.httpPrepare();
                this.$http.get(this.apiurl('user/'+user_id)).then(function (response) {
                    response = this.httpSuccess(response);
                    this.user = response.payload;
                    this.executeFunction(onSuccess, param);
                }, this.httpError)
            }
            return this;
        },

        resetUser: function () {
            this.user = null;
            return this;
        },

        isUserLoaded: function () {
            return this.is(this.user);
        },

        saveUser: function (images, onSuccess=null, param=null) {
            let formdata = new FormData();
            formdata.append('extra_image_file', images.image_file);
            formdata.append('extra_image_clean', images.image_clean);
            formdata.append('extra_signature_file', images.signature_file);
            formdata.append('extra_signature_clean', images.signature_clean);
            for ( var key in this.user ) { formdata.append(key, this.user[key]); }

            this.httpPrepare();
            this.$http.post(this.apiurl('user/'+this.user.id+'/save'), formdata, { headers: { 'Content-Type': 'multipart/form-data'} }).then(function (response) {
                response = this.httpSuccess(response);
                console.log('post response', response);
                this.user = response.payload;
                this.user.password = null;
                this.executeFunction(onSuccess, param);
            }, this.httpError)
        },

        disableUser: function (user_id, onSuccess=null, param=null) {
            this.httpPrepare();
            this.$http.put(this.apiurl('user/'+user_id+'/disable'), {}).then(function (response) {
                response = this.httpSuccess(response);
                this.executeFunction(onSuccess, param);
            }, this.httpError)
        },

        enableUser: function (user_id, onSuccess=null, param=null) {
            this.httpPrepare();
            this.$http.put(this.apiurl('user/'+user_id+'/enable'), {}).then(function (response) {
                response = this.httpSuccess(response);
                this.executeFunction(onSuccess, param);
            }, this.httpError)
        },


        banUser: function (user_id, onSuccess=null, param=null) {
            this.httpPrepare();
            this.$http.put(this.apiurl('user/'+user_id+'/ban'), {}).then(function (response) {
                response = this.httpSuccess(response);
                this.executeFunction(onSuccess, param);
            }, this.httpError)
        },

        unbanUser: function (user_id, onSuccess=null, param=null) {
            this.httpPrepare();
            this.$http.put(this.apiurl('user/'+user_id+'/unban'), {}).then(function (response) {
                response = this.httpSuccess(response);
                this.executeFunction(onSuccess, param);
            }, this.httpError)
        },

        getToken: function(user_id, onSuccess=null, param=null) {
            this.httpPrepare();
            this.$http.put(this.apiurl('user/'+user_id+'/token')).then(function (response) {
                response = this.httpSuccess(response);
                this.token = response.payload;
                this.executeFunction(onSuccess, param);
            }, this.httpError)
        },

        testMailUser: function (user_id, onSuccess=null) {
            this.httpPrepare();
            this.$http.put(this.apiurl('user/'+user_id+'/testmail'), {}).then(function (response) {
                response = this.httpSuccess(response);
                this.executeFunction(onSuccess, response);
            }, this.httpError)
        },

        loadCurrentUser: function (onSuccess=null, param=null) {
            this.httpPrepare();
            this.$http.get(this.apiurl('user/me')).then(function (response) {
                response = this.httpSuccess(response);
                this.$store.commit('setAuthUser', response.payload);
                this.executeFunction(onSuccess, param);
            }, this.httpError)
            return this;
        },

        /*
         *    Роли пользователей
         */

        loadRoles: function (onSuccess=null, param=null) {
            if (!this.isRolesLoaded()) {
                this.httpPrepare();
                this.$http.get(this.apiurl('user/roles')).then(function (response) {
                    response = this.httpSuccess(response);
                    if (response.result === 'success') {
                        this.roles = response.payload;
                        this.executeFunction(onSuccess, param);
                    }
                    else {
                        console.log(response);
                        this.result_err = response.error;
                    }
                }, this.httpErrors)
            }
        },

        resetRoles: function () {
            this.roles = [];
            return this;
        },

        isRolesLoaded: function () {
            return (this.roles !== null) && this.roles.length;
        },

        getRoleTitleById: function (id) {
            if (!this.is(id)) {
                return '';
            }

            if (this.roles[id]) {
                return this.roles[id];
            }

            return '';
        },

        /*
         *  Коллективы
         */


        loadTeams: function (onSuccess=null, param=null) {
            console.log('loadTeams');
            if (this.isTeamsLoaded()) { return this; }
            this.teams_loaded = false;
            this.teams = [];
            console.log('loadTeams');
            this.httpPrepare();
            this.$http.get(this.apiurl('team')).then(function (response) {
                response = this.httpSuccess(response);
                this.teams = response.payload;
                this.$store.commit('savePreloadTeams', this.teams);
                this.teams_loaded = true;
                this.executeFunction(onSuccess, param);
            }, this.httpError)
            return this;
        },

        resetTeams: function () {
            this.teams = [];
            return this;
        },

        isTeamsLoaded: function () {
            console.log('isTeamsLoaded 1');
            if ((this.teams !== null)  && this.teams.length) { return true; }
            console.log('isTeamsLoaded 2');
            if (!this.is(this.$store.state.pl.teams)) { return false; }
            console.log('isTeamsLoaded 3');
            this.teams = this.$store.state.pl.teams;
            return true;
        },

        getTeamById: function (id) {
            if (!this.is(id)) {
                return 'не указано';
            }

            for (let i=0; i<this.teams.length; i++) {
                if (this.teams[i].id === id) {
                    return this.teams[i];
                }
            }

            return null;
        },



        /*
         *  Панель
         */

        loadDashboard: function (onSuccess=null, param=null) {
            if (!this.isDashboardLoaded() ) {
                this.dashboard = null;
                this.httpPrepare();
                this.$http.get(this.apiurl('dashboard' )).then(function (response) {
                    response = this.httpSuccess(response);
                    this.dashboard = response.payload;
                    this.executeFunction(onSuccess, param);
                }, this.httpError)
            }
            return this;
        },

        isDashboardLoaded: function () {
            return (this.dashboard !== null) && this.dashboard;
        },

        resetDashboard: function () {
            this.dashboard = null;
            return this;
        },


        /*
         *  Водители
         */

        loadDrivers: function (onSuccess=null, param=null) {
            if (this.isDriversLoaded()) { return this; }
            this.drivers_loaded = false;
            this.drivers = [];
            this.httpPrepare();
            this.$http.get(this.apiurl('driver/a')).then(function (response) {
                response = this.httpSuccess(response);
                this.drivers = response.payload;
                this.$store.commit('savePreloadDrivers', this.drivers);
                this.drivers_loaded = true;
                this.executeFunction(onSuccess, param);
            }, this.httpError)
            return this;
        },

        resetDrivers: function () {
            this.drivers = [];
            return this;
        },

        isDriversLoaded: function () {
            if ((this.drivers !== null)  && this.drivers.length) { return true; }
            if (!this.is(this.$store.state.pl.drivers)) { return false; }
            this.drivers = this.$store.state.pl.drivers;
            return true;
        },

        getDriverById: function (id) {
            if (!this.is(id)) {
                return 'не указано';
            }

            for (let i=0; i<this.drivers.length; i++) {
                if (this.drivers[i].id === id) {
                    return this.drivers[i];
                }
            }

            return null;
        },


        /*
        *  Баланс
        */

        loadBalance: function (contractor_id, onSuccess=null, param=null) {
            if (!this.isBalanceLoaded() ) {
                this.balance = null;
                this.httpPrepare();
                this.$http.get(this.apiurl('finance/balance/'+contractor_id )).then(function (response) {
                    response = this.httpSuccess(response);
                    this.balance = response.payload;
                    this.executeFunction(onSuccess, param);
                }, this.httpError)
            }
            return this;
        },

        isBalanceLoaded: function () {
            return (this.balance !== null) && this.balance;
        },

        resetBalance: function () {
            this.balance = null;
            return this;
        },

        loadSelfBalance: function(onSuccess=null, param=null) {
            if (!this.isBalanceLoaded() ) {
                this.balance = null;
                this.httpPrepare();
                this.$http.get(this.apiurl('finance/balance/self' )).then(function (response) {
                    response = this.httpSuccess(response);
                    this.balance = response.payload;
                    this.executeFunction(onSuccess, param);
                }, this.httpError)
            }
            return this;
        },


        /*
         *   Финансы
         */

        createFinance: function (finance_info, onSuccess=null, param=null) {
            this.httpPrepare();
            this.$http.post(this.apiurl('finance/create'), {finance_info:finance_info}).then(function (response) {
                response = this.httpSuccess(response);
                if (response.result === 'success') {
                    console.log(response);
                    this.executeFunction(onSuccess, param);
                }
                else {
                    this.error_log(response.error);
                }
            },function (error) {
                this.error_log(error);
            })
        },

        stornoFinance: function (storno_info, onSuccess=null, param=null) {
            this.httpPrepare();
            this.$http.post(this.apiurl('finance/storno'), {storno_info:storno_info}).then(function (response) {
                response = this.httpSuccess(response);
                if (response.result === 'success') {
                    console.log(response);
                    this.executeFunction(onSuccess, param);
                }
                else {
                    this.error_log(response.error);
                }
            },function (error) {
                this.error_log(error);
            })
        },

        /*
         *   Список компаний
         */
        loadCountries: function (onSuccess=null, param=null) {
            if (this.isCountriesPreloaded()) { this.executeFunction(onSuccess, param); return this; }
            this.countries_loaded = false;
            this.countries = [];
            this.httpPrepare();
            this.$http.get(this.apiurl('country')).then(function (response) {
                response = this.httpSuccess(response);
                this.countries = response.payload;
                this.$store.commit('savePreloadCountries', this.countries);
                this.countries_loaded = true;
                this.executeFunction(onSuccess, param);
            }, this.httpError);
            return this;
        },

        isCountriesPreloaded: function () {
            if (!this.is(this.$store.state.pl.countries)) { return false; }
            this.countries = this.$store.state.pl.countries;
            return true;
        },

        loadErrorLog: function (name, onSuccess=null, param=null) {
            this.httpPrepare();
            this.$http.get(this.apiurl('log/errorlog/'+name)).then(function (response) {
                response = this.httpSuccess(response);
                this.executeFunction(onSuccess, param, response.payload);
            }, this.httpError);
        },

        doMagick: function (name, onSuccess=null, param=null) {
            this.httpPrepare();
            this.$http.get(this.apiurl('magick/'+name)).then(function (response) {
                response = this.httpSuccess(response);
                if (response.result==='success') {
                    miniToastr["success"](response.message, 'Каста прошла', CONSTANTS.TOAST_SUCCESS_LIFETIME);
                    this.executeFunction(onSuccess, param, response.payload);
                }
                else {
                    miniToastr["error"](response.error, 'Каста отбита', CONSTANTS.TOAST_ERROR_LIFETIME);
                }
            }, this.httpError);
        }

    },


    computed : {
    }

}

